<template>
  <img
    class="icon"
    src="@/assets/images/pencil.svg"
    width="16"
    height="17"
    alt=""
  />
</template>

<script setup lang="ts"></script>
